module.exports = __webpack_public_path__ + "img/fire_station.b2fe3b2c.png";